module.exports = __webpack_public_path__ + "img/bj.835db436.svg";